/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIReasonEnum } from './APIReasonEnum';
import {
    APIReasonEnumFromJSON,
    APIReasonEnumFromJSONTyped,
    APIReasonEnumToJSON,
} from './APIReasonEnum';

/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIPatchedInventoryMovementRequest
 */
export interface APIPatchedInventoryMovementRequest {
    /**
     * 
     * @type {string}
     * @memberof APIPatchedInventoryMovementRequest
     */
    source?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedInventoryMovementRequest
     */
    target?: string;
    /**
     * 
     * @type {number}
     * @memberof APIPatchedInventoryMovementRequest
     */
    amount?: number;
    /**
     * 
     * @type {APIReasonEnum}
     * @memberof APIPatchedInventoryMovementRequest
     */
    reason?: APIReasonEnum | null;
}



/**
 * Check if a given object implements the APIPatchedInventoryMovementRequest interface.
 */
export function instanceOfAPIPatchedInventoryMovementRequest(value: object): value is APIPatchedInventoryMovementRequest {
    return true;
}

export function APIPatchedInventoryMovementRequestFromJSON(json: any): APIPatchedInventoryMovementRequest {
    return APIPatchedInventoryMovementRequestFromJSONTyped(json, false);
}

export function APIPatchedInventoryMovementRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPatchedInventoryMovementRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'source': json['source'] == null ? undefined : json['source'],
        'target': json['target'] == null ? undefined : json['target'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'reason': json['reason'] == null ? undefined : APIReasonEnumFromJSON(json['reason']),
    };
}

export function APIPatchedInventoryMovementRequestToJSON(value?: APIPatchedInventoryMovementRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'source': value['source'],
        'target': value['target'],
        'amount': value['amount'],
        'reason': APIReasonEnumToJSON(value['reason']),
    };
}

